import { createFileRoute } from "@tanstack/react-router";

import { EnterpriseCaseDetailPage } from "@/features/enterprise/case-detail-page";
import { caseApplicationsQueryOptions } from "@/features/cases/queries";

// ロールガードは親 layout (`enterprise/route.tsx`) が ENTERPRISE 限定。
export const Route = createFileRoute("/_authenticated/enterprise/$id/")({
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(caseApplicationsQueryOptions(params.id)),
  component: EnterpriseCaseDetailPage,
});
